import useLazyQuery from 'api/hooks/useLazyQuery';
import permissions from 'api/Apollo/permissions';

import { buildVariables, GET_TAGS_WITH_PIPELINE_COUNT } from './tags-with-pipeline-count-query-builder';

export default function useLazyQueryTagsWithPipelineCount(options = {}) {
  const [executeQuery, { data, ...rest }] = useLazyQuery(GET_TAGS_WITH_PIPELINE_COUNT, {
    context: { permission: permissions.readTags },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
    ...options,
  });

  const fetchPipelineTags = queryParams => {
    const variables = buildVariables(queryParams);
    executeQuery({ variables });
  };

  return [fetchPipelineTags, buildResponse(data, rest)];
}

function buildResponse(data, rest) {
  if (data) {
    return {
      tags: data.tags,
      pagination: data.tagsAggregate.aggregate,
      ...rest,
    };
  }

  return {
    tags: [],
    pagination: { count: null },
    ...rest,
  };
}
